import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getLead, addCall } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { alertError, alertSuccess } from "../../utils/alerts";

const INIT_ORG = {
    customer: "",
    contact: "",
    source: "",
    service: "",
    lastContactDate: "",
    nextContactDate: "",
    comment: "",
}

const INIT_STATE = {
    lead: null,
    leadStage: "",
    activityDate: null,
    nextActivityDate: null,
    activityType: null,
    summary: null,
    justification: null,
};

export default function ViewLead() {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [lead, setLead] = useState(INIT_ORG);
    const [calls, setLeadSalesCall] = useState(null);
    const [state, setState] = useState(INIT_STATE);

    useEffect(() => {
        if(id){
            setLoading(true);
            getLead(id)
            .then((res) => { 
                if(res.data.success){
                    setLead(res.data.data);  
                    setLeadSalesCall(res.data.calls)
                    setLoading(false)
                }
            })
            .catch((err) => {
                console.log(err?.response?.data?.error)
                setTimeout(() => {
                    setLoading(false)
                }, 3500);
            });
        }
    }, [id]);

    const handleChange = (e) => {
        e.persist();
        setState((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = { ...state, lead:id };
        if(data.lead && data.activityDate && data.nextActivityDate && data.activityType && data.summary && data.leadStage
            && data.justification
        ){
            setLoading(true);
            addCall(data)
            .then((res) => {
                if(res.data.success){
                    alertSuccess(res.data.message);
                    window.location.reload();
                } else {
                    alertError(res.data.message)
                }
                setLoading(false);
                setTimeout(() => {
                    setLoading(false);
                }, 1500);
            })
            .catch((err) => {
                alertError(err?.response?.data?.error);
                setLoading(false);
            });
        }
    };

    return (
        <>
            {!loading && lead ? 
            <div className="spur-card-menu">
                <button type="button" data-toggle="modal" data-target="#modal" 
                    className="pull-right btn topbtn btn-primary">ADD SALES CALL
                </button>
            </div> : null }

            <h1 className="dash-title">
                <Link to="/sales/leads" style={{color: '#454545'}}><i className="fa fa-arrow-left"></i> Go Back</Link>
            </h1>

            <div className="row">
                <div className="col-md-12 d-flex">
                    <div className="card profile-box flex-fill mt-3">
                        <div className="card-body">
                            <h3 className="card-title" style={{fontSize: 20, fontWeight:'bold', marginBottom: 20}}>
                                Manage Lead 
                            </h3>
                            {!loading ?  <>
                                <ul className="personal-info">
                                    <li>
                                        <div className="title">Customer:</div>
                                        <div className="text"><span>{lead.customer?.name && lead.customer?.name} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Contact:</div>
                                        <div className="text">{lead.contact?.name && lead.contact?.name}</div>
                                    </li>
                                    <li>
                                        <div className="title">Source:</div>
                                        <div className="text">{lead.source && lead.source}</div>
                                    </li>
                                    <li>
                                        <div className="title">Service:</div>
                                        <div className="text"><span>{lead.service && lead.service} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Last Contact Date:</div>
                                        <div className="text"><span>{lead.lastContactDate && lead.lastContactDate} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Next Contact Date:</div>
                                        <div className="text"><span>{lead.nextContactDate && lead.nextContactDate} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Lead Stage:</div>
                                        <div className="text"><span>{lead.stage && lead.stage} </span></div>
                                    </li>
                                    <li>
                                        <div className="title">Comment/Note:</div>
                                        <div className="text"><span>{lead.comment && lead.comment} </span></div>
                                    </li>
                                </ul>
                            </>
                            : <Loader /> }
                        </div>
                    </div>
                </div>

                {(lead && lead?.history && lead?.history.length > 0) ? 
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card mt-4">
                        <div className="card-header">
                            <div className="spur-card-title">Lead History</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && lead && lead.history) ? 
                                    <div className="table-responsive">
                                        {(lead && lead.history.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr>
                                                <th>SN</th><th>Initiator</th><th>Activity</th><th>Justification</th>
                                                <th>Date</th><th>Time</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {lead && lead.history.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.initiator && row?.initiator?.first_name}</td>
                                                        <td>{row?.activity && row?.activity}</td>
                                                        <td>{row?.justification && row?.justification}</td>
                                                        <td>{row?.date && row?.date}</td>
                                                        <td>{row?.time && row?.time}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div> : null}

                {(calls && calls && calls.length > 0) ? 
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card">
                        <div className="card-header">
                            <div className="spur-card-title">Sales Calls</div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {(!loading && calls && calls) ? 
                                    <div className="table-responsive">
                                        {(calls && calls.length > 0) ?
                                        <table className="table text-left text-caps table-bordered" id="myTable">
                                            <thead><tr>
                                                <th>SN</th><th>Activity Type</th><th>Summary</th><th>Activity Date</th>
                                                <th>Next Activity Date</th></tr>
                                            </thead>
                                            <tbody>
                                                {calls && calls.map((row, index) => 
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{row?.activityType && row?.activityType}</td>
                                                        <td>{row?.summary && row?.summary}</td>
                                                        <td>{row?.activityDate && row?.activityDate}</td>
                                                        <td>{row?.nextActivityDate && row?.nextActivityDate}</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table> : 
                                        <div className="alert alert-danger myerror d-block">No record found.</div> }
                                    </div>
                                : <Loader /> }
                            </div>
                        </div>
                    </div>
                </div> : null}
            </div>      


            <div id="modal" className="modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">ADD SALES CALL TO THIS LEAD</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Activity Date <span>*</span></label>
                                    <input type="date" name="activityDate" className="form-control" required 
                                        placeholder="Activity Date" 
                                        onChange={handleChange} 
                                        defaultValue={state.activityDate && state.activityDate }  disabled={loading} 
                                    />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Next Activity Date <span>*</span></label>
                                    <input type="date" name="nextActivityDate" className="form-control" required 
                                        placeholder="Next Activity Date" 
                                        onChange={handleChange} 
                                        defaultValue={state.nextActivityDate && state.nextActivityDate }  disabled={loading} 
                                    />
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">Activity Type <span>*</span></label>
                                    <select className="form-control form-select" name="activityType" id="activityType" required 
                                    onChange={handleChange} defaultValue={state.activityType && state.activityType} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="Email">Email</option>
                                        <option value="Phone Call">Phone Call</option>
                                        <option value="Physical Meeting">Physical Meeting</option>
                                        <option value="Outbound Call">Outbound Call</option>
                                        <option value="Inbound Call">Inbound Call</option>
                                        <option value="Presentation">Presentation</option>
                                    </select>
                                </div>
                                <div className="col-md-6 form-group">
                                    <label className="control-label">New Lead Stage: <span>*</span></label>
                                    <select className="form-control form-select" name="leadStage" id="leadStage" required 
                                    onChange={handleChange} defaultValue={state.leadStage && state.leadStage} disabled={loading}>
                                        <option value=''>Select...</option>
                                        <option value="suspect">Suspect</option>
                                        <option value="prospect">Prospect</option>
                                        <option value="opportunity">Opportunity</option>
                                        <option value="won">Won</option>
                                        <option value="lost">Lost</option>
                                    </select>
                                </div>
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Justification for Change: <span>*</span></label>
                                    <input type="text" name="justification" className="form-control" required 
                                        placeholder="Justification (Enter NA if not applicable)" onChange={handleChange} 
                                        defaultValue={state.justification && state.justification }  disabled={loading} 
                                    />
                                </div>
                                
                                <div className="col-md-12 form-group">
                                    <label className="control-label">Summary/Comments/Notes: <span>*</span></label>
                                    <textarea cols="33" rows="3" name="summary" className="form-control" required 
                                    placeholder="Summary/Comments/Notes" 
                                        onChange={handleChange} defaultValue={state.summary || ""} >    
                                    </textarea>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12 form-group">
                                    <button 
                                        type="submit" 
                                        className="btn" 
                                        disabled={loading}
                                        onClick={handleSubmit} >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 



        </>
    );
}
